import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { carriers } from 'helpers/orders';
import { getPaymentMethodNameApi } from 'api';
import { BackdropCircular } from 'components';


const OrderPaymentShippingData = ({order}) => {
  const dispatch = useDispatch();
  const {payment, extension_attributes, shipping_description} = order;
  const {method} = payment;
  const { paymentMethods, loadingPaymentMethodName } =  useSelector((state: IReduxState) => state.store_orders);
  const paymentMethodName = paymentMethods[method];
  const multiCardsData = extension_attributes?.cc_multi || [];
  useEffect(() => {
    if (!paymentMethodName) {
      getPaymentMethodNameApi({dispatch, method});
    }
  }, []);

  const shippingMethod = () => {
    const {method, total: {shipping_amount}} = extension_attributes.shipping_assignments[0].shipping;

    if (method === 'flatrate_flatrate') {
      return `${shipping_description} $${shipping_amount.toFixed(2)}`;
    }

    return shipping_description;
  };
  return (
    <TableContainer>
      <Table className="inheritTable">
        <TableHead>
          <TableRow>
            <TableCell width="10%" />
            <TableCell width="30%">Payment information</TableCell>
            <TableCell>Shipping & Handling Information</TableCell>
            {!!extension_attributes.shipment_tracks?.length &&
            <>
              <TableCell width="10%" />
              <TableCell>Carrier and Tracking Number</TableCell>
            </>
            }
            <TableCell width="10%" />
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell width="10%" />
            <TableCell width="30%" className="align-top">
              <div className="flex-column">
                <span>{paymentMethodName}</span>
                <div className="mt-4 ml-4">
                  {method === 'multi_cc_split' ?
                    <>
                      {multiCardsData.map((card, index) => (
                        <React.Fragment key={`cc-${index}`}>
                          <div>
                            {`xxxx-${card.last4} - ${card.type} [${card.exp_month}/${card.exp_year}]`}
                          </div>
                        </React.Fragment>
                      ))}
                    </>
                    :
                    <>
                      <div className="flex flex-wrap w-full">
                        <span>{paymentMethodName} Type:</span>
                        <span className="ml-2">{payment.cc_type}</span>
                      </div>
                      <div className="flex flex-wrap w-full">
                        <span>{paymentMethodName} Number:</span>
                        <span className="ml-2">xxxx-{payment.cc_last4}</span>
                      </div>
                    </>
                  }
                </div>
              </div>
            </TableCell>
            <TableCell className="align-top">
              {shippingMethod()}
            </TableCell>
            {!!extension_attributes.shipment_tracks?.length &&
            <>
              <TableCell width="10%" />
              <TableCell className="align-top">
                {extension_attributes.shipment_tracks.map((shipment, index) => {
                  const {entity_id, carrier_code, track_number} = shipment || {};
                  const carrier = carriers.find((carrier) => carrier.code == carrier_code)?.title || '';
                  const isNotLastTrack = extension_attributes.shipment_tracks.length !== index + 1;
                  return (
                    <div className="flex-column" key={entity_id}>
                      <div className="flex flex-wrap">
                        <span>{'Carrier: '}</span>
                        <span>{carrier}</span>
                      </div>
                      <div className="flex flex-wrap">
                        <span>{'Tracking Number: '}</span>
                        <span>{track_number}</span>
                      </div>
                      {isNotLastTrack && <Divider className="my-3 bg-muted" />}
                    </div>
                  );
                })}
              </TableCell>
            </>
            }
            <TableCell width="10%" />
          </TableRow>
        </TableBody>
      </Table>
      <BackdropCircular loading={loadingPaymentMethodName} />
    </TableContainer>
  );
};

export default OrderPaymentShippingData;
